import seoConfig from "../seo-routes.json";

export type SeoRoute = {
  path: string;
  canonicalPath?: string;
  title: string;
  description: string;
  image: string;
  eyebrow: string;
  heading: string;
  summary: string;
  ctaHref: string;
  ctaLabel: string;
  index: boolean;
};

export const siteOrigin = seoConfig.origin;
export const siteName = seoConfig.siteName;
export const seoRoutes = seoConfig.routes as SeoRoute[];

export function normalizeSeoPath(pathname: string) {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "");
}

export function seoRouteForPath(pathname: string) {
  const normalizedPath = normalizeSeoPath(pathname);
  return seoRoutes.find((route) => route.path === normalizedPath);
}
